/* eslint-disable react/prop-types */
import { Formik } from 'formik';
import MaskedInput from 'react-text-mask';

import { ReactComponent as PersonIcon } from 'assets/icons/person.svg';
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg';
import Input from 'components/Input';
import Button from 'components/Button';

function LoginForm({ onSubmit, disabled: formDisabled }) {
  return (
    <Formik initialValues={{ username: '', password: '' }} onSubmit={onSubmit}>
      {({ values, errors, handleChange, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <MaskedInput
              mask={[
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                '-',
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                '-',
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
              ]}
              type="text"
              name="username"
              id="username"
              placeholder="Nomor Ujian"
              value={values.username}
              onChange={handleChange}
              disabled={formDisabled || isSubmitting}
              autoFocus
              render={(ref, props) => (
                <Input
                  ref={(input) => ref(input)}
                  label="Nomor Ujian:"
                  icon={<PersonIcon className="w-6 text-gray-500" />}
                  error={errors.username}
                  {...props}
                />
              )}
            />
          </div>

          <div className="mb-10">
            <MaskedInput
              mask={[
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                '-',
                /[0-9]/,
                /[0-9]/,
                '-',
                /[0-9]/,
                /[0-9]/,
              ]}
              type="text"
              name="password"
              id="password"
              placeholder="Tanggal Lahir (2001-02-26)"
              value={values.password}
              onChange={handleChange}
              disabled={formDisabled || isSubmitting}
              render={(ref, props) => (
                <Input
                  ref={(input) => ref(input)}
                  label="Tanggal Lahir:"
                  icon={<LockIcon className="w-6 text-gray-500" />}
                  error={errors.password}
                  {...props}
                />
              )}
            />
          </div>
          <Button
            type="submit"
            color="primary"
            loading={isSubmitting}
            disabled={formDisabled || isSubmitting}
            block
          >
            Login
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default LoginForm;
